import ParametrosView from "../../components/estoque/ParametrosView";

export default function ParametrosEstoque() {
  return <ParametrosView />;
}
